<template>
  <div>
    <v-text-field
      ref="inputAmount"
      v-bind="$attrs"
      v-model="amountValue"
      :prepend-icon="icon"
      @click:prepend="toggleAmountType"
      type="number"
      :rules="rules"
    >
    </v-text-field>
  </div>
</template>

<script>
const CURRENCY = "currency";
const PERCENTAGE = "percentage";
export default {
  name: "AmountInput",
  props: {
    value: { type: [String, Number], default: 0 },
    type: {
      type: String,
      default: CURRENCY,
      validator: val => [CURRENCY, PERCENTAGE].includes(val)
    }
  },
  data() {
    return {
      error: "",
      rules: [
        v => !String(v)?.includes('-') || "Debe ser un número positivo",
        v => v >= 0 || "El campo no puede ser menor a 0",
        v =>
          this.type !== PERCENTAGE ||
          v <= 100 ||
          "Si es porcentaje, debe ser menor o igual a 100"
      ]
    };
  },
  computed: {
    amountValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      }
    },
    icon() {
      return this.type === CURRENCY ? "mdi-currency-usd" : "mdi-percent";
    }
  },
  watch: {
    amountValue() {
      this.validate();
      if (this.type === PERCENTAGE) {
        this.error = this.validatePercentage();
        return;
      }

      if (this.type === CURRENCY) {
        this.error = this.validateNumber();
        return;
      }
    },
    type() {
      this.validate();
    }
  },
  methods: {
    toggleAmountType() {
      const newAmount = this.type === CURRENCY ? PERCENTAGE : CURRENCY;
      this.$emit("update:type", newAmount);
    },
    validatePercentage() {
      if (this.amountValue > 100)
        return "El porcentaje no puede exceder el 100%";
      if (this.amountValue < 0) return "El porcentaje no puede ser negativo";
      return "";
    },
    validateNumber() {
      if (this.amountValue < 0) return "El monto no puede ser negativo";
      return "";
    },
    validate() {
      this.$refs.inputAmount?.validate();
    }
  }
};
</script>
